module.exports = __webpack_public_path__ + "static/media/keyboard-outline.881b4b68.svg";